<template>
  <div class="login">
    <!-- 登录弹窗 -->
    <x-dialog
      v-model="show"
      :width="'82.67'"
      :opacity="0.5"
      :borderRadius="'20px'"
      overflow="visible"
      position="absolute"
    >
      <div slot="content" class="login-popup">
        <p>手机号码</p>
        <div class="phone">
          <input
            @blur="checkPhone"
            placeholder="请输入手机号"
            v-model="phoneNumber"
            type="tel"
            maxlength="11"
          />
        </div>
        <p>验证码</p>
        <div class="get-code">
          <input
            @blur="inputBlur"
            placeholder="请输入验证码"
            v-model="valiCode"
            type="tel"
            maxlength="4"
          />
          <div @click.stop="getValiCode">
            {{ secondHandel ? second + "秒后重发" : "点击获取验证码" }}
          </div>
        </div>
        <div class="login-btn" @click="login">登录</div>
      </div>
    </x-dialog>
  </div>
</template>

<script>
import xDialog from '@/components/Popup/x-dialog';
import { loginExUser } from '@/mock/mock';
import ApplyMethods from '@/utils/applyMethods.js'
export default {
  name: 'Login',
  components: { xDialog },
  data () {
    return {
      show: false,
      phoneNumber: '',
      valiCode: '',
      secondHandel: null,
      second: 60,
      inputBlur: null,
      getValiCode: null
    };
  },
  props: {
    value: {}, // 是否显示，使用v-model绑定
    loginSuccess: {
      type: Function
    }
    // opacity: {
    //   type: Number,
    //   default: 0.2
    // },
  },
  watch: {
    value (newval, oldval) {
      this.show = newval;
    }
  },
  mounted () {
    const applyMethods = new ApplyMethods(this)
    this.inputBlur = applyMethods.inputBlur
    this.getValiCode = applyMethods.getValiCode.bind(this)
  },
  methods: {
    checkPhone () {
      const re = /^1\d{10}$/g;
      this.phoneError = re.test(this.phoneNumber) ? '' : '手机号错误';
      this.inputBlur();
    },
    /** 登录 */
    async login () {
      if (this.islogin) {
        return;
      }
      this.islogin = true;
      let errorMsg = '';
      if (this.phoneNumber === '') {
        errorMsg = '手机号不能为空';
      } else if (this.valiCode === '') {
        errorMsg = '验证码不能为空';
      } else if (this.phoneError !== '') {
        errorMsg = '手机号格式错误';
      }
      if (errorMsg) {
        this.toast.show(errorMsg, !1);
        this.islogin = false;
      } else {
        loginExUser({
          mobile: this.phoneNumber,
          verifyCode: this.valiCode
        }).then((res) => {
          console.log(this, this.success)
          this.islogin = false;
          const code = res.data.code;
          if (code === '200' || code === '304') {
            this.toast.show('登录成功', !0);
            this.show = false
            this.success(res.data.data)
          } else {
            this.toast.show(res.data.text || '登录失败', !1);
          }
        });
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.noticeInterval);
  }
};
</script>

<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '~@/assets/css/mixin.styl'
.login-popup
  position relative
  z-index 10
  margin rpx(97) auto 0
  text-align left
  p
    sc(28, #000000)
    font-weight 500
    lh(40)
    ml(56)
  input
    width rpx(500)
    height rpx(87)
    // lh(87)
    border-bottom rpx(2) solid #CACACA
    margin rpx(0) rpx(60) rpx(64)
    font-size rpx(32)
    &::-webkit-input-placeholder
      sc(32, #DBDBDB)
  .phone
    position relative
    div
      position absolute
      right 0
      top rpx(28)
      sc(24, #C40000)
      lh(34)
  .get-code
    position relative
    div
      position absolute
      right rpx(66)
      top rpx(15)
      text-decoration underline
      sc(24, #999999)
      lh(34)
      padding rpx(20) 0
  .login-btn
    wh(318, 84)
    border rpx(2) solid #979797
    bora(24)
    sc(30, #333333)
    fj()
    justify-content center
    margin rpx(22) auto rpx(97)
</style>



// WEBPACK FOOTER //
// src/starcharge/plugin/loginPopup/loginpopup.vue